import React, { useCallback, useMemo, useState } from "react";
import CustomBreadcumbs from "../../../../component/atoms/custom-breadcumbs";
import TitlePages from "../../../../component/atoms/title-pages";
import { IconFilterReport } from "../../../../asset";
import DrawerFilterOrderReport from "./__components/drawer";
import TableReportOrderNoData from "./__components/table/table-report-order-no-data";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalDDLDatePeriod } from "../../../../store/reducer/globalDDL.reducer";
import {
  EXPORT_ORDER_REPORT,
  LIST_ORDER_REPORT,
} from "../../../../api/contractAPI.api";
import { POSTGetListReportServices } from "../../../../service/POSTGetListReport";
import { message } from "antd";
import TableOrderReportWithData from "./__components/tables";
import { doExport } from "../../../../api/baseAPI";

const MainReportOrder = () => {
  const { token } = useSelector((state) => state.auth);
  const { globalDDLDatePeriod } = useSelector((state) => state.globalDDL);
  const {
    globalOrderFromReport,
    globalDepotName,
    globalDeliveryType,
    globalCustomerReport,
    globalOrderStatus,
  } = useSelector((state) => state.globalMSS);

  const dispatch = useDispatch();

  const [params, setParams] = useState();

  const [isDrawerOpened, setIsDrawerOpened] = useState(false);
  const [listData, setListData] = useState([]);
  const [statePayload, setStatePayload] = useState({});

  const onClickFilter = useCallback(() => {
    setIsDrawerOpened(true);
  }, []);

  const onCloseFilter = useCallback(() => {
    setIsDrawerOpened(false);
  }, []);

  const resetRedux = useCallback(() => {
    dispatch(setGlobalDDLDatePeriod({}));
  }, [dispatch]);

  const getListOrderReport = useCallback(
    async (newParams, payload) => {
      const newBody = {
        ...payload,
        page: newParams?.page,
        limit: newParams?.limit,
      };
      setStatePayload(newBody);

      const res = await POSTGetListReportServices(
        token,
        LIST_ORDER_REPORT,
        newBody
      );
      if (res?.success) {
        setListData(res?.list);
      } else {
        if (res?.errorCode === 500) {
          message.error(res?.message);
        }
      }
      onCloseFilter();
    },
    [onCloseFilter, token]
  );

  const onApplyFilter = useCallback(
    async (col) => {
      const orderFromReport = [...globalOrderFromReport];
      const payloadOrderFrom =
        orderFromReport && orderFromReport.length === 0
          ? { order_from: { list: [], exclude: false } }
          : orderFromReport && orderFromReport.includes(-1)
          ? { order_from: { list: ["ALL"], exclude: false } }
          : {
              order_from: {
                list: orderFromReport.map((el) => el?.id),
                exclude: false,
              },
            };

      const depots = [...globalDepotName];
      const payloadDepot =
        depots && depots.length === 0
          ? { depot: { list_id: [], exclude: false } }
          : depots && depots.includes(-1)
          ? { depot: { list_id: [-1], exclude: false } }
          : {
              depot: {
                list_id: depots.map((el) => el?.id),
                exclude: false,
              },
            };

      const datePeriod = globalDDLDatePeriod;
      const payloadDatePeriod = {
        ...datePeriod,
      };

      const deliveryType = [...globalDeliveryType];
      const payloadDeliveryType =
        deliveryType && deliveryType.length === 0
          ? { delivery_type: { list_id: [], exclude: false } }
          : deliveryType && deliveryType.includes(-1)
          ? { delivery_type: { list_id: [-1], exclude: false } }
          : {
              delivery_type: {
                list_id: deliveryType.map((el) => el?.id),
                exclude: false,
              },
            };

      const customer = [...globalCustomerReport];
      const payloadCustomer =
        customer && customer.length === 0
          ? { customer: { list_id: [], exclude: false } }
          : customer && customer.includes(-1)
          ? { customer: { list_id: [-1], exclude: false } }
          : {
              customer: {
                list_id: customer.map((el) => el?.id),
                exclude: false,
              },
            };

      const orderStatus = [...globalOrderStatus];
      const payloadOrderStatus =
        orderStatus && orderStatus.length === 0
          ? { order_status: { list: [], exclude: false } }
          : orderStatus && orderStatus.includes(-1)
          ? { order_status: { list: ["ALL"], exclude: false } }
          : {
              order_status: {
                list: orderStatus.map((el) => el?.order_status),
                exclude: false,
              },
            };

      const columnSelection = col;

      const payload = {
        page: 1,
        limit: 10,
        order: "",
        filter: "",
        connector: "",
        other: {
          filter_selection: {
            ...payloadOrderFrom,
            ...payloadDepot,
            period_date: {
              ...payloadDatePeriod,
            },
            ...payloadDeliveryType,
            ...payloadCustomer,
            ...payloadOrderStatus,
          },
          column_selection: {
            ...columnSelection,
          },
        },
      };

      const params = { page: 1, limit: 10 };

      await getListOrderReport(params, payload);
    },
    [
      getListOrderReport,
      globalCustomerReport,
      globalDDLDatePeriod,
      globalDeliveryType,
      globalDepotName,
      globalOrderFromReport,
      globalOrderStatus,
    ]
  );

  const isBtnExportEnabled = useMemo(() => {
    if (listData && listData.length === 0) {
      return false;
    }
    return true;
  }, [listData]);

  const btnExportOrderReport = useCallback(async () => {
    const { filter_selection, column_selection } = statePayload?.other;

    const body = {
      filter_selection,
      column_selection,
    };

    try {
      const res = await doExport(EXPORT_ORDER_REPORT, token, body);
      if (res?.status === 200) {
        const pdfBlob = new Blob([res?.data]);

        const url = window.URL.createObjectURL(pdfBlob);

        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", `report_order.pdf`);

        document.body.appendChild(tempLink);
        tempLink.click();

        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
        return;
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        // setIsFailedModalOpen(true);
        // setMessageFailed(error?.message);
        return;
      }
      if (error?.response?.status === 500) {
        message.error("Internal Server Error");
        return;
      }
    }
  }, [statePayload, token]);

  return (
    <>
      <CustomBreadcumbs
        jmlLevel={2}
        menuLevel1={"Report"}
        menuLevel2={"Report Order"}
      />
      <TitlePages name={"Order Report"} />
      <div className="flex justify-between mt-5">
        <button
          className={`${
            isBtnExportEnabled ? "btn-export-enabled" : "btn-export-disabled"
          }`}
          onClick={
            isBtnExportEnabled ? () => btnExportOrderReport() : undefined
          }
        >
          Export
        </button>
        <button className="container-btn-filter-report" onClick={onClickFilter}>
          <span className="span-btn-filter-report">Filter</span>
          <img src={IconFilterReport} alt="icon-filter-report" />
        </button>
      </div>
      <div className="container-pages-table">
        {listData?.data?.length > 0 ? (
          <TableOrderReportWithData data={listData} />
        ) : (
          <>
            <TableReportOrderNoData openFilter={onClickFilter} />
          </>
        )}
      </div>
      <DrawerFilterOrderReport
        onClose={onCloseFilter}
        open={isDrawerOpened}
        appyFilter={onApplyFilter}
      />
    </>
  );
};

export default MainReportOrder;
